<template>
  <div>
    <b-modal id="modal_editar_itens" title="Editar Item do Pedido" ref="my-modal" size="xl" ok-title="Salvar"
      cancel-title="Cancelar" cancel-variant="outline-secondary" @show="resetModal" @hidden="resetModal" @ok="handleOk"
      scrollable>
      <tela-nova-editar-item-pedido :json="itemSelecionado" @update:grade="updatedGradeItens">

      </tela-nova-editar-item-pedido>

      <!--       <pre>{{ itemSelecionado }}</pre>-->
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BFormSelect, BCol, BButton,
} from 'bootstrap-vue';
import { mapActions, mapGetters } from 'vuex';
import ProductionItem from '@/views/app/operacoes/pedidosVendas/swipper/swipperItensProdutos.vue';
import GradePedidos from '@/views/app/operacoes/pedidosVendas/tabelaGrade/gradePedidos.vue';
import { push } from 'echarts/lib/component/dataZoom/history';
import axios from 'axios';
import ECommerceProductDetails from '@/views/app/CartECommerce/e-commerce-product-details/ECommerceProductDetails.vue';
import InserirItemModal from '@/views/app/operacoes/pedidosVendas/inserirItemModal.vue';
import TelaNovaEditarItemPedido from '@/views/app/operacoes/pedidosVendas/modal/TelaNovaEditarItemPedido.vue';
import Swal from 'sweetalert2';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import { getTotvsBaseUrl } from '@/utils/totvsApi';

export default {
  components: {
    TelaNovaEditarItemPedido,
    InserirItemModal,
    ECommerceProductDetails,
    GradePedidos,
    BButton,
    BModal,
    BCol,
    BFormSelect,
    ProductionItem,
  },

  data() {
    return {
      itemSelecionado: {},
      selected_cod_marca: null,
      selected_categoria: null,
      selected_referencia: null,
      selected_embalagem: null,
      valorUnitario: null,
      categoriasOptions: [],
      referenciasOptions: [],
      embalagensOptions: [],
      itensTabela: [],
      gradeAtual: [],
      arrayEmbalagens: [],
      index: null,
    };
  },
  mounted() {
    this.clearjsonTelaNovaPedido();
    this.itemSelecionado = {};
  },
  methods: {
    ...mapActions('intensPedido', [
      'itensMarcaPedido',
      'itensCategoriaPedido',
      'itensReferenciaPedido',
      'itensEmbalagemPedido',
      'itensdetalhes',
      'setListTabelaItens',
      'setIsLoadingReferencia',
      'setIsLoadingReferenciaRestante',
      'setjsonTelaNovaPedido',
      'clearjsonTelaNovaPedido',
      'clearModalItens',
      'buscaCorGradeItens',
    ]),

    async getReferenciaPedido() {
      await this.clearjsonTelaNovaPedido();
      if (this.selected_cod_marca && this.selected_categoria) {
        await this.itensReferenciaPedido({
          selected_cod_marca: this.selected_cod_marca,
          selected_categoria: this.selected_categoria,
        });
        this.selected_referencia = null;
        this.selected_embalagem = null;
        await this.getEmbalagemPedido();
      }
    },
    async getEmbalagemPedido(item) {
      console.log('getEmbalagemPedido', item);
      await this.setIsLoadingReferencia(true);

      if (item.item.cod_marca && item.item.cod_categ && item.item.cod_referencia) {
        try {
          await this.itensEmbalagemPedido({
            selected_referencia: item.item.cod_referencia,
            precoId: this.getFormData.dataCapaPedido.tabelaprecoid,
          });
          await this.getImagemPedido(item);
          await this.setIsLoadingReferencia(false);
        } catch (error) {
          console.error('Erro ao processar a referência:', item.item.cod_referencia, error);
        }
      } else {
        console.warn('Condições não atendidas ou referência inválida', item.item.cod_referencia);
      }
    },
    async getImagemPedido(item) {
      const vazio = [];
      await this.setjsonTelaNovaPedido(vazio);
      console.log('item', item);
      this.index = item.index;
      const embalagens = this.$store.getters['intensPedido/getEsEmbalagens'];
      const embalagensValues = embalagens.slice(1).map((embalagem) => embalagem.value);

      const itemImagem = {
        codMarca: item.item.cod_marca,
        codCateg: item.item.cod_categ,
        tabelaprecoId: this.getFormData.dataCapaPedido.tabelaprecoid,
        clienteIderp: this.getFormData.dataCapaPedido.clienteiderp,
        familiaComercialId: item.item.cod_referencia,
      };

      const response = await this.itensdetalhes(itemImagem);

      let data = {};

      if (response) {
        if (response.success) {
          console.log('ITEM NÃO ENCONTRADO', itemImagem.familiaComercialId);
          return;
        }
        data = response;
      }

      const newGradeAtual = {
        item_id: data.item_id,
        item_name: data.item_name,
        item_price: data.item_price,
        item_descricao: data.item_descricao,
        item_caracteristicas: data.item_caracteristicas,
        item_composisao: data.item_composisao,
        item_indicacoes: data.item_indicacoes,
        item_img_princial: data.item_img_princial,
        item_marca: data.item_marca,
        cod_marca: data.cod_marca,
        referencia: data.referencia,
        gradeItem: data.gradeItem,
        imagens: data.imagens,
        subItens: item.subItens,
        embalagens: [],
      };

      const baseUrl = await getTotvsBaseUrl();
      for (const embalagemValue of embalagensValues) {
        console.log(item.item.cod_marca && item.item.cod_categ && this.getFormData.dataCapaPedido.tabelaprecoid && item.item.cod_referencia);
        if (item.item.cod_marca && item.item.cod_categ && this.getFormData.dataCapaPedido.tabelaprecoid && item.item.cod_referencia) {
          const itemBuscar = {
            codMarca: item.item.cod_marca,
            codCateg: item.item.cod_categ,
            tabelaprecoId: this.getFormData.dataCapaPedido.tabelaprecoid,
            clienteIderp: this.getFormData.dataCapaPedido.clienteiderp,
            familiaComercialId: item.item.cod_referencia,
            cdnEmbalagem: embalagemValue.cdn_embalagem,
            codEmbal: embalagemValue.cdn_embalagem,
          };

          try {
            const url = `${baseUrl}/grade/${itemBuscar.familiaComercialId}/${itemBuscar.codEmbal}/${itemBuscar.clienteIderp}/${this.getFormData.dataCapaPedido.tabelaprecoid}`;
            const response = await fetch(url);

            if (!response.ok) {
              throw new Error(`Erro na solicitação: ${response.statusText}`);
            }

            const data = await response.json();

            if (data) {
              newGradeAtual.embalagens.push({
                descricao_embalagem: embalagemValue.des_embalag,
                cdn_embalagem: embalagemValue.cdn_embalagem,
                grade: data,
              });
            }
          } catch (error) {
            console.error('Erro ao fazer a solicitação:', error);
          }
        }
      }
      if (newGradeAtual.item_id) {
        console.log('newGradeAtual', newGradeAtual);
        this.itemSelecionado = newGradeAtual;
        await this.setjsonTelaNovaPedido(newGradeAtual);
      }
    },

    async calcularImposto() {
      const url = 'http://10.112.16.63:8180/pwsales/web/simulaimposto';
      const data = {
        CabecPedido: [
          {
            'c-pr-cod-estabel': this.getFormData.dataCapaPedido.estabelecimentoid,
            'c-pr-nome-abrev': this.getFormData.dataCapaPedido.clientenomeabreviado,
            'c-pr-nat-operacao': this.getFormData.dataCapaPedido?.naturezaoperacaoid || '6101',
            'c-pr-cod-canal-venda': this.getFormData.dataCapaPedido?.canal_venda_id || '',
            'c-pr-it-codigo': this.gradeAtual[0].itemPequeno,
            'd-pr-quantidade': 1.0000,
            'd-pr-vl-preori-ped': Number(this.getFormData.dataItensPedido.item_price),
            'd-pr-per-des-item': 0.0000,
            'p-simulacao': 0,
            'p-uf-ds': this.getFormData.enderecoEntrega.ufid,
            'p-cidade-ds': this.getFormData.enderecoEntrega.clienteenderecocidade,
            'p-contr-icms': this.getFormData.dataCapaPedido.clienteisentoie ? 1 : 0,
            'p-tp-frete': 0,
            'p-tp-tabpre': this.getFormData.dataCapaPedido.tabelaprecoid,
            'p-cod-cond-pagto': Number(this.getFormData.dataCapaPedido.condicaopagamentoid),
            Itens: [{
              itCodigo: this.gradeAtual[0].itemPequeno,
            }],
          },
        ],
      };

      try {
        const response = await axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (response.data.CabecPedido && response.data.CabecPedido[0] && response.data.CabecPedido[0]['d-pr-unitario'] === 0) {
          console.log('ZERO IMPOSTO');
        } else {
          this.getFormData.dataItensPedido.item_price = response.data.CabecPedido[0]['d-pr-unitario'] / (1 - (response.data.CabecPedido[0]['d-aliq-icms-reducao'] / 100));
        }

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            text: 'Imposto calculado!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        });
      } catch (error) {
        console.error('Erro ao fazer a chamada à API:', error);
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao calcular impostos',
          timer: 2000,
        });
      }
    },

    async show(item) {
      await this.$bvModal.show('modal_editar_itens');
      this.itemSelecionado = item;
      await this.getEmbalagemPedido(item);
    },
    async resetModal() {
      this.selected_cod_marca = null;
      this.selected_categoria = null;
      this.selected_referencia = null;
      this.selected_embalagem = null;
      this.getFormData.dataItensPedido.item_price = null;
      this.clearModalItens();
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.addItens();
      this.handleSubmit();
      this.clearModalItens();
    },
    handleSubmit() {
      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn');
      });
    },
    handleRemoveItem(item) {
      console.log('REMOVENDO ITEM', item);
      this.itensTabela = this.itensTabela.filter((i) => i.itemId !== item.item_id && i.pedidoItemQuantidade !== item.valor);
      console.log('TABELA ATUAL', this.itensTabela);
    },
    updatedGradeItens(value) {
      console.log('updatedGradeItens', value);
      this.itensTabela = value.map((item) => ({
        codMarca: this.selected_cod_marca,
        familiaComercialId: item.referencia,
        cdncor: item.cdn_cor,
        des_cor: item.des_cor,
        cdn_tamanho: item.cdn_tamanho,
        itemId: item.item_id,
        item_descricao: `${item.nome} ${item.tamanho} ${item.des_cor}`,
        descricao_referencia: item.nome,
        pedidoItemQuantidade: parseInt(item.valor, 10),
        marca: item.marca,
        embalagem: item.embalagem,
        cdn_embalagem: item.cdn_embalagem,
        precoUnitario: parseFloat(item.preco),
        valorTotal: +item.preco * parseFloat(item.valor),
        pedidoItemQuantidadeSaldo: 0,
        pedidoItemQuantidadeFaturada: 0,
        pedidoitemseq: 0,
        desc_tamanho: item.tamanho,
      }));
      console.log('itensTabela', this.itensTabela);
    },
    async addItens() {
      console.log('addItens', this.itensTabela);

      // Agrupa itens por referência
      const itensAgrupadosPorReferencia = this.itensTabela.reduce((acc, item) => {
        const referencia = item.familiaComercialId; // Usando o campo referencia do item
        if (!acc[referencia]) {
          acc[referencia] = {
            CodMarca: item.codMarca,
            DescricaoMarca: item.marca,
            CodReferencia: referencia,
            DescricaoReferencia: item.descricao_referencia,
            referencia: `${referencia}-${item.item_descricao}`,
            Qtde: 0,
            PrecoUnitario: item.precoUnitario,
            ValorTotal: 0,
            sequencia: Object.keys(acc).length + 1,
            itens: [],
            editar: {
              cod_marca: item.codMarca,
              cod_categ: this.selected_categoria,
              cod_referencia: referencia,
              precoId: this.getFormData.dataCapaPedido.tabelaprecoid,
            },
          };
        }
        acc[referencia].Qtde += item.pedidoItemQuantidade;
        acc[referencia].ValorTotal += item.pedidoItemQuantidade * item.precoUnitario;
        acc[referencia].itens.push(item);

        return acc;
      }, {});
      console.log('itensAgrupadosPorReferencia', itensAgrupadosPorReferencia);
      for (const referencia in itensAgrupadosPorReferencia) {
        const item = itensAgrupadosPorReferencia[referencia];
        await this.setListTabelaItens(item);
      }
    },

  },
  computed: {
    ...mapGetters('intensPedido', [
      'getEsMarcas',
      'getIsLoadingMarca',
      'getEsCategorias',
      'getIsLoadingCategoria',
      'getEsReferencias',
      'getIsLoadingReferencia',
      'getEsEmbalagens',
      'getIsLoadingEmbalagem',
      'getFormData',
      'getlistarTabelaItens',
    ]),
  },
};
</script>

<style scoped>
.container-images-prod {
  width: 500px;
}
</style>
